/**
 * The external services GET /api/health reports, with one reader for every client.
 */

import { z } from 'zod';
import type { FactorDataSources } from './factorRegistry';

export interface ExternalApiHealth {
  oddsApi: boolean;
  statsApi: boolean;
  aiApi: boolean;
  /** Absent from servers older than the MSF switch; absent counts as on. */
  msf?: boolean;
}

/** Before the first check answers, nothing is shown as down. */
export const ASSUMED_HEALTHY: ExternalApiHealth = { oddsApi: true, statsApi: true, aiApi: true };

/** What a failed health request means: every service is treated as down. */
export const ALL_DOWN: ExternalApiHealth = {
  oddsApi: false,
  statsApi: false,
  aiApi: false,
  msf: false,
};

const HealthResponseSchema = z.object({
  health: z.object({
    externalApis: z.object({
      oddsApi: z.boolean(),
      statsApi: z.boolean(),
      aiApi: z.boolean(),
      msf: z.boolean().optional(),
    }),
  }),
});

/** The service flags in a /api/health body, or null when the body is not that shape. */
export function readExternalApis(body: unknown): ExternalApiHealth | null {
  const parsed = HealthResponseSchema.safeParse(body);
  return parsed.success ? parsed.data.health.externalApis : null;
}

/** The data sources factor availability depends on, from the health flags. */
export function factorDataSourcesFrom(health: ExternalApiHealth): FactorDataSources {
  return { msf: health.msf };
}
